import * as Helper from './helpers.mjs';

class EntityAction {
    constructor (options) {
        this.options = options;
    }

    setIndex(index) {
        this.index = index;
    }

    getEntityName(e) {
        return $(e.target).closest('tr').find("td:nth-of-type(2)").text();
    }

    checkDeletion() {
        var section = Helper.getPageInfo("section");
        if (this.options.route.includes("/delete")) {
            if (typeof BroadcastChannel != "undefined") {
                const channel = new BroadcastChannel("stockSearchChannel");
                channel.postMessage({
                    refresh: section
                });
            }
        }
    }

    doAction(e) {
        if (this.options.custom) {
            return this.index[this.options['custom']](e);
        }

        var row = e.target.closest('tr');
        var id = row.getAttribute("data-id");

        var name = row.dataset.name;
        if (!name) {
            name = this.getEntityName(e);
        }
        var modalId;

        if (e.target.nodeName !== "BUTTON"){
            modalId = $(e.target).closest('button').attr('data-modal-open');
        } else {
            modalId = e.target.dataset.modalOpen;
        }

        if (this.options.isLink && !modalId) {
            return this.linkAction(e);
        }

        this.confirmAction(id, modalId, name);
    }

    linkAction(e) {
        e.preventDefault();
        // get rowId
        var id = $(e.target).parents("tr").attr('data-id');
        var url = $(e.target).attr("href");

        if (e.target.nodeName !== "BUTTON") {
            url = e.target.parentElement.getAttribute("href");
        }

        this.doLink(e, id, url);
    }

    doLink(e, id, url) {
        if (!url) {
            var extraValue = this.options.extraValue ? this.options.extraValue.value : null;
            url = this.options.route + '/' + (extraValue ? extraValue + '/' : '') + (id ? id : '');
        }

        if (e.shiftKey === true) {
            window.open(url, '');
        } else if (e.ctrlKey === true || this.options.newTab === true) {
            window.open(url, '_blank');
        } else {
            location.href = url;
        }
    }

    confirmAction(id, modalId, name) {
        //TODO:  Use WeaveModal class to manage message confirmation OR move to Helper class
        var modal = $("#" + modalId);

        if (modalId) {
            modal.find(".modal-header .plural").hide();
            modal.find(".modal-header .singular").show();
            modal.find(".modal-body .items").show().text(name);
            modal.addClass("active");
            modal.find(".modal-footer menu").off("click").on("click", '.btn[data-action="confirm"]', (e) => {
                modal.removeClass("active");
                this.actionConfirmed(id, e);
            });
        } else {
            this.actionConfirmed(id);
        }
    }

    actionConfirmed(id, e) {
        if (this.options['onConfirm']) {
            this.options['onConfirm'](id, this.index);
        } else if (this.options.isLink) {
            return this.doLink(e, id);
        } else {
            this.doEntityAction(id, e);
        }
    }

    doEntityAction(id, e) {
        var extraValue = this.options.extraValue ? this.options.extraValue.value : null;
        var url = this.options.route + '/' + (extraValue ? extraValue + '/' : '') + id + (this.options.includeButtonId && e ? ('/' + e.target.id) : '');
        this.index.loading(this.options.loadingMessage ? this.options.loadingMessage : 'Loading...');

        fetch(url, {
            method: "POST"
        }).then(r => {
            return r.json();
        }).then(result => {
            if (this.options['callback']) {
                this.options['callback'](result);
            }

            this.index.stopLoading();

            if (result.success) {
                Helper.notify(this.options.successMessage ? this.options.successMessage : 'Done');
                if (id === this.index.currentWeave && this.options.route == '/weave/weaves/delete') {
                    location.href = '/weave';
                    return;
                }
                this.checkDeletion();
                this.index.loadList();
                Helper.updateWeaveBadges();
            } else {
                Helper.notifyError(result.msg ? result.msg : (result.error ? result.error : 'Unknown error'));
            }
        }).catch(error => {
            console.log(error);
            this.index.stopLoading();
            Helper.notifyError("An error occurred");
        });
    }

    /* actions for multiple selection */
    rowsAction(e) {
        if (this.options.custom) {
            return this.index[this.options['custom']](e);
        }

        if (this.options.isLink) {
            return this.linkAction(e);
        }

        /* if (this.options.hasOwnProperty('multiselect') && !this.options.multiselect) {
            return this.doAction(e);
        } */
        
        var rowIds = this.index.getSelectedRowIds();

        var modalId;
        if (e.target.nodeName !== "BUTTON") {
            modalId = $(e.target).closest('.btn').attr('data-modal-open');
        } else {
            modalId = e.target.dataset.modalOpen;
        }

        if (rowIds.length > 0) {
            if (modalId) {
                this.confirmRowsAction(e, modalId, rowIds);
            } else {
                this.doRows(rowIds);
            }
        } else {
            Helper.notify(this.options.noneSelectedMessage ? this.options.noneSelectedMessage : "No items selected");
        }
    }

    confirmRowsAction(e, modalId, rowIds) {
        var modal = $("#" + modalId);
        var rowNames = this.index.getSelectedRowNames(rowIds);
        
        if(rowIds.length == 1){
            modal.find(".modal-header .plural").hide();
            modal.find(".modal-header .singular").show();
        } else {
            modal.find(".modal-header .plural").show();
            modal.find(".modal-header .singular").hide();
            modal.find(".modal-header .plural-count").text(rowIds.length);
        }
        modal.find(".modal-body .items").show().text(rowNames);
        modal.find(".modal-body .count").show().text(rowIds.length);
        modal.addClass("active");
        modal.find(".modal-footer menu").off("click").on("click", ".btn", (e) => {
            if($(e.target).closest('.btn').attr('data-action') == "confirm"){
                modal.removeClass("active");
                this.doRows(rowIds);            
            }
        });
    }

    doRows(rowIds) {
        var url;
        var promises = [];
        this.index.loading(this.options.loadingMessage ? this.options.loadingMessage : 'Loading...');
        rowIds.forEach(id => {
            var extraValue = this.options.extraValue ? this.options.extraValue.value : null;
            url = this.options.route + '/' + (extraValue ? extraValue + '/' : '') + id;
            var promise = $.post(url); //fetch(url, { method: "POST" });
            promises.push(promise);
            if (id === this.index.currentWeave && this.options.route == '/weave/weaves/delete') {
                this.deletedCurrentWeave = true;
            }
        });
        Promise.allSettled(promises).then(this.doRowsCallback.bind(this));
    }

    async doRowsCallback(results) {
        var rejected = 0;
        for (var p of results) {
            if (p.status == "fulfilled" && p.value.error) {
                await Helper.notifyError(p.value.error);
                rejected++;
            } else if (p.status == "rejected") {
                var error = p.reason.responseJSON.msg;
                await Helper.notifyError(error);
                rejected++;
            }
        }

        this.index.stopLoading();
        if (!rejected) {
            Helper.notify(this.options.multiselectSuccessMessage ? this.options.multiselectSuccessMessage : 'Done');
        }
        if (this.deletedCurrentWeave) {
            location.href = '/weave';
            return;
        }
        this.index.loadList();
        this.checkDeletion();
        Helper.updateWeaveBadges();
    }
}

export { EntityAction };